import React, { Component } from "react";

import { Button as AntButton, Dropdown, Space } from "antd";
import {
  EditOutlined,
  LoadingOutlined,
  DeleteOutlined,
  MoreOutlined,
} from "@ant-design/icons";

class DropdownBtn extends Component {
  constructor(props) {
    super(props);
  }
  buildDropdownActions(section) {
    const items = [
      {
        label: "Editar",
        key: "edit-section",
        icon: <EditOutlined />,
        onClick: () => this.props.handleEditSection(section),
      },
      {
        danger: true,
        label: "Eliminar",
        key: "eliminar-contrato",
        icon: <DeleteOutlined />,
        onClick: () => this.props.handleDelete(),
      },
    ];
    return { items };
  }
  render() {
    return (
      <Dropdown menu={this.buildDropdownActions(this.props.section)}>
        <AntButton>
          <Space>
            Acciones
            <div className="acciones-contrato">
              <MoreOutlined />
            </div>
          </Space>
        </AntButton>
      </Dropdown>
    );
  }
}

export default DropdownBtn;



// WEBPACK FOOTER //
// ./src/views/Configurator/components/DropdownBtn.jsx